<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <!-- Header -->
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/add-user"
        >
          Nouveau Utilisateur
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <div style="min-width: 220px">
          <input
            type="text"
            class="form-control text-black rounded-1"
            placeholder="Recherche rapide..."
            v-model="users.searchTerm"
            @input="onQuickSearch"
          />
        </div>
        <button
          class="btn d-flex align-items-center gap-2 fw-medium"
          :class="showFilters ? 'btn-primary' : 'btn-outline-secondary'"
          type="button"
          @click="showFilters = !showFilters"
        >
          <feather-icon icon="SlidersIcon" size="15" />
          Filtres
          <span
            v-if="activeFiltersCount > 0"
            class="badge bg-white text-primary rounded-pill ms-1"
            style="font-size: 11px; min-width: 20px"
          >
            {{ activeFiltersCount }}
          </span>
        </button>
      </div>
    </div>

    <!-- Filter Panel -->
    <transition name="filter-slide">
      <div v-if="showFilters" class="filter-panel border-top border-bottom bg-light px-4 py-3">
        <div class="row g-3">
          <!-- Nom complet -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Nom complet</label>
            <input
              v-model="users.searchName"
              type="text"
              class="form-control form-control-sm"
              placeholder="Chercher par nom..."
            />
          </div>

          <!-- Fonction -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Fonction</label>
            <v-select
              v-model="selectedFunction"
              :options="FunctionsList"
              label="name"
              placeholder="Toutes les fonctions"
              @search="onSearchFunct"
              class="vs--sm"
            >
              <template #no-options>
                <span class="text-muted small">Taper pour chercher...</span>
              </template>
            </v-select>
          </div>

          <!-- Ville -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Ville</label>
            <v-select
              v-model="selectedCity"
              :options="CitiesList"
              label="name"
              placeholder="Toutes les villes"
              class="vs--sm"
            />
          </div>

          <!-- Zone -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Zone</label>
            <v-select
              v-model="selectedZone"
              :options="ZonesList"
              label="name"
              placeholder="Toutes les zones"
              class="vs--sm"
            />
          </div>

          <!-- Compte -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Statut du compte</label>
            <select v-model="users.searchAccount" class="form-select form-select-sm">
              <option value="">Tous</option>
              <option :value="1">Compte activé</option>
              <option :value="0">Compte désactivé</option>
            </select>
          </div>

          <!-- Date de création -->
          <!-- <div class="col-md-4 col-lg-3">
            <label class="filter-label">Date de création</label>
            <input
              v-model="createdDate"
              type="date"
              class="form-control form-control-sm"
            />
          </div> -->

     

          <!-- Créé par -->
          <div class="col-md-4 col-lg-3">
            <label class="filter-label">Créé par</label>
            <v-select
              v-model="selectedCreatedBy"
              :options="CuserList"
              label="name"
              placeholder="Tous les utilisateurs"
              @search="onSearchUsers"
              class="vs--sm"
            >
              <template #no-options>
                <span class="text-muted small">Taper pour chercher...</span>
              </template>
            </v-select>
          </div>

          <!-- Actions -->
          <div class="col-12 d-flex align-items-center gap-2 pt-2 border-top mt-1">
            <button class="btn btn-sm btn-primary px-4 d-flex align-items-center gap-1" @click="applyFilters">
              <feather-icon icon="FilterIcon" size="14" />
              Appliquer les filtres
            </button>
            <button
              class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
              @click="resetFilters"
            >
              <feather-icon icon="RotateCcwIcon" size="14" />
              Réinitialiser
            </button>
            <span v-if="activeFiltersCount > 0" class="text-muted small ms-2">
              {{ activeFiltersCount }} filtre{{ activeFiltersCount > 1 ? 's' : '' }} actif{{ activeFiltersCount > 1 ? 's' : '' }}
            </span>
          </div>
        </div>
      </div>
    </transition>

    <!-- Table -->
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field == 'logout_time'">
            {{ props.row.logout_time ? getDate(props.row.logout_time) : "" }}
          </span>
          <span v-else-if="props.column.field == 'active'">
            <div class="switch">
              <input
                type="checkbox"
                class="switch-input"
                :id="'switch-' + props.row.id"
                :checked="props.row.active"
                @change="toggleAdActive(props.row)"
              />
              <label class="switch-label" :for="'switch-' + props.row.id"></label>
            </div>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'EditUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                    Modifier
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'HistoryUserPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i class="flaticon-clock lh-1 me-8 position-relative top-1"></i>
                    Historique
                  </a>
                </li>
                <li v-if="auth.can('CONNEXION_USER')">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="hashUser(props.row)"
                  >
                    <i class="ph ph-sign-in lh-1 me-8 position-relative top-1"></i>
                    Login
                  </a>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent :pagination="users" :offset="9" @paginate="fetchData" />
    </div>
  </div>

  <!-- Login URL Modal -->
  <div class="modal fade" id="modal_login_user" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Url de connexion</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <div class="alert alert-warning" role="alert">
              Merci d'ouvrir ce lien dans un autre navigateur ou de vous connecter avec ce lien après vous être déconnecté.
            </div>
            <div class="d-flex">
              <div class="mb-0 me-1" style="width: 100%">
                <input :value="hashData" disabled class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import { computed, defineComponent, onMounted, reactive, ref } from "vue";

export default defineComponent({
  name: "UsersList",
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();

    const headers = [
      { label: "Nom Complet", field: "name" },
      { label: "Email", field: "email" },
      { label: "Téléphone", field: "phone" },
      { label: "Fonction", field: "type" },
      { label: "Date Création", field: "created_at" },
      { label: "Dernière Connexion", field: "logout_time" },
      { label: "Statut", field: "active" },
      { label: "Action", field: "actions" },
    ];

    const rows = ref([]);
    const loading = ref(false);
    const showFilters = ref(false);

    // Filter v-select refs
    const selectedFunction = ref(null);
    const selectedCity = ref(null);
    const selectedZone = ref(null);
    const selectedCreatedBy = ref(null);

    // Date filter refs
    const createdDate = ref("");

    // Dropdown option lists
    const FunctionsList = ref<any[]>([]);
    const CitiesList = ref<any[]>([]);
    const ZonesList = ref<any[]>([]);
    const CuserList = ref<any[]>([]);

    const users = reactive({
      searchTerm: "",
      searchName: "",
      searchFunction: "",
      searchCity: "",
      searchUser: "",
      searchAgency: "",
      searchDateFrom: "",
      searchDateTo: "",
      searchAccount: "",
      searchConnect: "",
      searchSlDate: "",
      searchElDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Count active filters for the badge
    const activeFiltersCount = computed(() => {
      let count = 0;
      if (users.searchName) count++;
      if (selectedFunction.value) count++;
      if (selectedCity.value) count++;
      if (selectedZone.value) count++;
      if (users.searchAccount !== "") count++;
      if (createdDate.value) count++;
      if (selectedCreatedBy.value) count++;
      return count;
    });

    // Quick search debounce timer
    let quickSearchTimer: ReturnType<typeof setTimeout> | null = null;
    function onQuickSearch() {
      if (quickSearchTimer) clearTimeout(quickSearchTimer);
      quickSearchTimer = setTimeout(() => fetchData(1), 400);
    }

    // v-select async search handlers
    async function onSearchFunct(search: string, loading: (v: boolean) => void) {
      if (!search || search.length < 2) return;
      loading(true);
      try {
        const res = await api.get("/api/auth/list_role", { params: { search } });
        FunctionsList.value = res.data;
      } catch {
        // silent
      } finally {
        loading(false);
      }
    }

    async function onSearchUsers(search: string, loading: (v: boolean) => void) {
      if (!search || search.length < 2) return;
      loading(true);
      try {
        const res = await api.get("/api/auth/users", {
          params: { searchName: search, per_page: 20, page: 1 },
        });
        CuserList.value = (res.data.users?.data || []).map((u: any) => ({
          id: u.id,
          name: u.name,
        }));
      } catch {
        // silent
      } finally {
        loading(false);
      }
    }

    function applyFilters() {
      users.current_page = 1;
      users.searchFunction = selectedFunction.value?.id || "";
      users.searchCity = selectedCity.value?.id || "";
      users.searchAgency = selectedZone.value?.id || "";
      users.searchUser = selectedCreatedBy.value?.id || "";
      users.searchDateFrom = createdDate.value || "";
      fetchData(1);
    }

    function resetFilters() {
      selectedFunction.value = null;
      selectedCity.value = null;
      selectedZone.value = null;
      selectedCreatedBy.value = null;
      createdDate.value = "";

      Object.assign(users, {
        searchTerm: "",
        searchName: "",
        searchFunction: "",
        searchCity: "",
        searchUser: "",
        searchAgency: "",
        searchDateFrom: "",
        searchAccount: "",
        searchConnect: "",
        searchSlDate: "",
        searchElDate: "",
        current_page: 1,
      });

      fetchData(1);
    }

    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/users`, {
          params: {
            searchTerm: users.searchTerm,
            searchName: users.searchName,
            searchFunction: users.searchFunction,
            searchCity: users.searchCity,
            searchUser: users.searchUser,
            searchAgency: users.searchAgency,
            searchDateFrom: users.searchDateFrom,
            searchAccount: users.searchAccount,
            searchConnect: users.searchConnect,
            searchSlDate: users.searchSlDate,
            searchElDate: users.searchElDate,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    // Load static filter lists on mount
    onMounted(async () => {
      fetchData();

      try {
        const [citiesRes, zonesRes, rolesRes] = await Promise.all([
          api.get("/api/auth/citiesList"),
          api.get("/api/auth/ListZone"),
          api.get("/api/auth/list_role"),
        ]);
        CitiesList.value = citiesRes.data;
        ZonesList.value = zonesRes.data;
        FunctionsList.value = rolesRes.data;
      } catch (err) {
        console.error("Failed to load filter lists", err);
      }
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function toggleAdActive(row: any) {
      Swal.fire({
        text: "Vous voulez désactiver ce compte ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, désactiver!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await api.post(`/api/auth/user_active/${row.id}`, {
            active: Number(!row.active),
          });
          if (res.data.message == "success") {
            fetchData();
            showToast("Utilisateur est bien modifé", "success");
          }
        }
      });
    }

    const hashData = ref("");
    async function hashUser(row: any) {
      const data = new FormData();
      data.append("userId", String(row.id));
      const res = await api.post(`/api/auth/handelHashUser`, data);
      if (res.data.msg == "success" && res.data.hash && res.data.hash != "") {
        hashData.value = res.data.hash;
        const modalElement = document.getElementById("modal_login_user");
        if (modalElement) {
          const modal = new Modal(modalElement);
          modal.show();
        }
      }
    }

    return {
      rows,
      headers,
      fetchData,
      getDate,
      loading,
      users,
      toggleAdActive,
      auth,
      hashUser,
      hashData,
      showFilters,
      activeFiltersCount,
      selectedFunction,
      selectedCity,
      selectedZone,
      selectedCreatedBy,
      createdDate,
      FunctionsList,
      CitiesList,
      ZonesList,
      CuserList,
      onSearchFunct,
      onSearchUsers,
      onQuickSearch,
      applyFilters,
      resetFilters,
    };
  },
});
</script>

<style scoped>
/* Filter panel slide transition */
.filter-slide-enter-active,
.filter-slide-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
  overflow: hidden;
  max-height: 600px;
}
.filter-slide-enter-from,
.filter-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.filter-panel {
  background-color: #f8f9fc !important;
}

.filter-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
}

/* Make v-select match sm form controls */
:deep(.vs--sm .vs__dropdown-toggle) {
  min-height: 31px;
  padding: 0 6px;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  border-color: #dee2e6;
}
:deep(.vs--sm .vs__search),
:deep(.vs--sm .vs__selected) {
  font-size: 0.875rem;
  margin: 0;
  padding: 0 2px;
}
:deep(.vs--sm .vs__actions) {
  padding: 0 4px;
}
</style>
